import { getRequest } from '.'

export const getInstances = async (): Promise<wowaudit.Instance[]> => {
  return await getRequest(`/api/instances`)
}
